<template>
	<div class="binding-body">
		<div class="search-box">
				<div class="input-box">
					<span>员工名称：</span>
					<el-input
						v-model="staffName"
						placeholder="员工名称"
						class="name-input"
						size="mini"
						@keyup.enter.native="tableReload"
						></el-input>
				</div>
				<div class="input-box">
					<span>员工状态：</span>
					<el-select v-model="staffDisabled" class="select-box" size='mini' placeholder="员工状态">
						<el-option :value="0" label="全部"></el-option>
						<el-option :value="1" label="启用"></el-option>
						<el-option :value="2" label="停用"></el-option>
					</el-select>
				</div>
				<div class="input-box-btn">
					<el-button
						type="primary"
						class="fx-btn"
						size="small"
						plain
						@click="tableReload">查询</el-button>
				</div>
			</div>
        <div class="table-box">
            <el-table
				:stripe='true'
				ref='multipleTable'
				class="grid-content"
				size='mini'
				:data="tableData"
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange">
				<el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<el-table-column
					prop="staffName"
					label="员工名称"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="staffNumber"
					label="员工编号"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="tel"
					label="联系方式"
					align="center"
					min-width="150">
				</el-table-column>
                <el-table-column
					label="员工状态"
					align="center"
					min-width="150">
                    <template slot-scope="scope">
						<span v-if="scope.row.staffDisabled === false" style="color:green">启用</span>
						<span v-if="scope.row.staffDisabled === true" style="color:red">停用</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="roleName"
					label="员工角色"
					align="center"
					min-width="160">
					<template slot-scope="scope">
						<span v-if='scope.row.roleCount > 1'>多角色</span>
						<span v-else>{{scope.row.roleName}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="page-box">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20,40, 60, 100]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
			</div>
        </div>
		<div class="binding-foot">
            <el-button class="btn" plain type="primary" size='small' @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary" size='small' @click="saveClick">确认</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'binding',
	props: {
		bindId: String,
		sessionStoreId: String,
		isShow: Boolean
	},
	data () {
		return {
			staffName: '',
			staffDisabled: 0,
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			isCheck: {},
			checkArr: [],
			pageList: [],
			tableHeight: '90%'
		}
	},
	watch: {
		bindId: {
			handler (val) {
				this.roleId = val
			},
			immediate: true
		},
		isShow: {
			handler (val) {
				console.log(val)
				if (val === true) {
					this.staffName = ''
					this.staffDisabled = 0
					this.checkArr = []
					this.tableReload()
				}
			},
			immediate: true
		}
	},
	methods: {
		toggleSelection () {
			let toggArr = []
			let tempData = this.isCheck[this.page.number]
			if (tempData !== null && tempData.length > 0) {
				for (let i = 0; i < tempData.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (tempData[i].staffid === this.tableData[j].staffid) {
							toggArr.push(this.tableData[j])
						}
					}
				}
			}
			if (toggArr) {
				toggArr.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection()
			}
		},
		tableReload () {
			let params = {
				shopid: this.sessionStoreId,
				type: 1,
				staffName: this.staffName,
				page: this.page.number,
				size: this.page.size,
				staffDisabled: this.staffDisabled
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/addUserByShop`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data.recordList
					this.total = res.data.recordCount
					this.$nextTick(function () {
						if (this.isCheck[this.page.number]) {
							this.toggleSelection()
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionChange (val) {
			this.isCheck[this.page.number] = val
			this.pageList.push(this.page.number)
			let array = this.pageList
			var temp = [] // 一个新的临时数组
			for (var i = 0; i < array.length; i++) {
				if (temp.indexOf(array[i]) === -1) {
					temp.push(array[i])
				}
			}
			this.pageList = temp
		},
		cancelClick () {
			this.$emit('update:dialogVisible', false)
			this.$emit('update:isShow', false)
		},
		saveClick () {
			this.checkArr = []
			if (this.pageList.length > 0) {
				for (let i = 0; i < this.pageList.length; i++) {
					let b = this.isCheck[this.pageList[i]]
					for (let j = 0; j < b.length; j++) {
						this.checkArr.push(b[j].staffid)
					}
				}
				console.log(this.checkArr)
			}
			if (this.checkArr.length === 0) {
				this.$message.error('请选择至少一个员工！')
				return false
			}
			let params = {
				shopid: this.sessionStoreId,
				userIds: this.checkArr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/addRelatedShopUser`,
				data: params
			}).then(res => {
				if (res.resultFlag === true) {
					this.$emit('cancel', false)
					this.$message.success(res.message)
				} else {
					this.$message.error(res.message)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :720px;
	flex-direction: column;
    height :400px;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :265px;
			margin-bottom:10px
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
    .table-box{
		width :100%;
        padding-bottom :10px;
        height:calc(100% - 130px);
		.page-box{
			text-align :center
		}
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left: 65px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
